import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-process-template.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import './process-template.css';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import { IWeightedProductFilter } from '../../models/IWeightedProductFilter';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import { formatMessage } from '../../translations/format-message';
import AddProcessTemplatePopupHOC from './hoc/add-process-template-popup-hoc';
// import './process.css';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Header from '../../shared-components/header/header';
import { DeleteIcon, EditIcon, PlusIcon, RefreshIcon } from '../../shared-components/svgs/svgs';
import AddEditProcessTemplate from './components/add-edit-process-template';
import ProcessTemplateDetails from './process-template-details';

const ProcessTemplate = (props: any) => {
  const { preferencesStore, processTemplateStore } = useStore();
  const {
    GetProcessTemplateListService,
    allProcessTemplate,
    processTemplateList,
    deleteProcessTemplateState,
    DeleteProcessTemplateService,
    resetDeleteProcessTemplate,
    resetProcessTemplateDetail,
    addUpdateProcessTemplateState,
    resetAddUpdateProcessTemplateState,
    GetProcessTemplateByIdService,
    processTemplateDetails,
    processTemplateState,
    getAllProcessTemplateState,
  } = processTemplateStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allProcessTemplateListData = allProcessTemplate;

  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [filterObj, setFilterObj] = useState<IWeightedProductFilter>({
    TenantId: -1,
    ProductName: '',
    Sku: '',
    ColumnOrder: '',
    StartDate: '',
    EndDate: '',
  });
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProcessTemplateListServiceHandler = () => {
    GetProcessTemplateListService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit
    );
  };

  useEffect(() => {
    getProcessTemplateListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: processTemplateList?.PagingDetails?.CurrentPage,
      totalPages: processTemplateList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [processTemplateList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProcessTemplateListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProcessTemplateListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (language !== lang) {
      getProcessTemplateListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdateProcessTemplateState.success) {
      resetAddUpdateProcessTemplateState();
      getProcessTemplateListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateProcessTemplateState.success]);

  useEffect(() => {
    if (deleteProcessTemplateState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteProcessTemplate();
      getProcessTemplateListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteProcessTemplateState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getProcessTemplateListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteProcessTemplateService(
      Number(getTenantIdFromLocalStorage()),
      selectedId
    );
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProcessTemplateDetail();
    props.deletePopupToggleHandler();
  };

  const openAddProcessTemplateHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetProcessTemplateDetail();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  function formatDate(date: Date) {
    const day = date.getDate(); // 13
    const month = date.getMonth(); // 11 (months are 0-indexed, so add 1)
    const year = date.getFullYear(); // 2024
    return new Date(year, month, day);
  }

  const filterHandler = (filter: string) => {
    // getProductListServiceHandler("added_date DESC", encodeURIComponent(filter));
    // setFilterString(encodeURIComponent(filter));
    // closePanelhandler();
    // props.filterPopupToggleHandler();
    // setIsFilterCleared(false);
  };

  const filterParams = (
    obj: IWeightedProductFilter,
    isfilterCleard: boolean
  ) => {
    // if (isfilterCleard) {
    //   setFilterObj({
    //     ...obj,
    //     EndDate: null,
    //     StartDate: null,
    //     ColumnOrder: `${getFieldName(sortColumn)}  ${sortOrder}`,
    //     TenantId: -1,
    //   });
    //   getProductListServiceHandler("added_date DESC");
    //   closePanelhandler();
    //   setIsFilterCleared(true);
    //   setFilterString("");
    // } else {
    //   setFilterObj({
    //     ...obj,
    //     ColumnOrder: `${getFieldName(sortColumn)}  ${sortOrder}`,
    //     TenantId:
    //       getTenantIdFromLocalStorage() === "-1"
    //         ? Number(selectedTenantId)
    //         : Number(getTenantIdFromLocalStorage()),
    //   });
    // }
    props.filterPopupToggleHandler();
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddProcessTemplateHandler,
        icon: <EditIcon/>,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProcessTemplateManagement,
          'Edit'
        ),
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon/>,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProcessTemplateManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.ProcessTemplateManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'TemplateName',
      text: formatMessage('template_name'),
      classes: 'show-Elipses',
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
      // sort: true,
      // onSort: (field: string, order: 'asc' | 'desc') => {
      //   // Call your handler function with the order value
      //   setSortField(field);
      //   setSortOrder(order);
      //   getProcessListServiceHandler();
      // }
    },
    {
      dataField: 'Remarks',
      text: formatMessage('process_template_remarks'),
      classes: 'show-Elipses',
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  return (
    <>
      {props.showAddProcessTemplatePopup && (
        <AddEditProcessTemplate
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_process_template"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_process_template_confirm"
          isLoading={deleteProcessTemplateState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header className='col-lg-6 col-md-6 col-sm-6' label="process_template_title" />
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon/>
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.ProcessTemplateManagement,
                'Add'
              ) && (
                <li title={formatMessage('add_process_template')}>
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddProcessTemplateHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      {' '}
                      <PlusIcon />
                    </span>
                    <FormattedMessage id="add_process_template" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllProcessTemplateState.inProgress ||
            processTemplateState.inProgress ||
            deleteProcessTemplateState.inProgress) && (
            <FormLoader
              loading={
                getAllProcessTemplateState.inProgress ||
                processTemplateState.inProgress ||
                deleteProcessTemplateState.inProgress
              }
            />
          )}
          {allProcessTemplateListData &&
          allProcessTemplateListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allProcessTemplateListData && (
                      <Grid
                        data={allProcessTemplateListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        // sort={{dataField: 'ProcessName', order: sortOrder}}
                        // remote = {{sort: true}}
                        // onTableChange={onTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allProcessTemplateListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={processTemplateList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_process_template" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_process_template_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.ProcessTemplateManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddProcessTemplateHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          {' '}
                          <PlusIcon />
                        </span>
                        <FormattedMessage id="add_process_template" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.TemplateName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <svg
                  onClick={closePanelHandler}
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x ms-auto d-block"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <ProcessTemplateDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(
  AddProcessTemplatePopupHOC(DeletePopupHOC(observer(ProcessTemplate)))
);
